import { Button, } from "@mui/material";
import { postAsync } from "../../utils/httpClient";
import { useState } from "react";
import { CustomAlretDialog } from "./Dialog";

export const MemoRegister = ({ idx, memo, refreshList }) => {


  // 다이어로그 메세지
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  // Dialog 열,닫 기
  const showDialog = (message) => {
    setDialogMessage(message);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const hendleRegisterMemo = () => {
    postAsync("/v2/thirdparty/inquiry/modifiy", {
      idx,
      memo
    }, sessionStorage.getItem('gonggam-accessToken')).then((res) => {
      if (res.message === "success") {
        showDialog("수정이 완료되었습니다.");
        refreshList();
      }
      else {
        showDialog("수정도중 오류가 발생하였습니다.");
      }
    })
      .catch((error) => {
        console.error("Error:", error);
        showDialog(`에러내용 : ${error}`);
      });
  }
  return (
    <div style={{ marginTop: 10, display: 'flex', justifyContent: 'end' }}>
      <Button
        variant="contained"
        onClick={() => hendleRegisterMemo()}
      >
        수정하기
      </Button>
      {dialogOpen && (
        <CustomAlretDialog
          open={dialogOpen}
          message={dialogMessage}
          close={handleDialogClose}
        />
      )}
    </div>

  );

};